import React from 'react';
import { Box, Flex, Link, Text, Image } from '@chakra-ui/react';
import { UndraggableImage } from 'components/shared/UndraggableImage';
import HowToBecomeJikaClubMember from 'assets/how-to-become-jika-club-member.png';
import DownloadApp from 'assets/download-app.png';
import WalkIn from 'assets/walk-in.png';
import SearchBar from 'assets/search-bar.png';
import TakeAction from 'assets/take-action.png';
import AppStoreDownload from 'assets/app-store-download.png';
import GooglePlayDownload from 'assets/google-play-download.png';
import { motion } from 'framer-motion';

const AnimatedImage = motion(Image);

export const Footer = React.memo(() => {
  return (
    <Flex mt={12} background="pink.600" justifyContent="center">
      <Flex p={4} flexDirection="column" width="100%" maxWidth={1080}>
        <UndraggableImage
          src={HowToBecomeJikaClubMember}
          maxWidth={{ base: 320, sm: 350, md: 400, lg: 450, xl: 500 }}
          mt={{ base: '-50px', md: '-60px' }}
        />
        <Flex
          flexDirection={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
        >
          <Flex p={2} flexDirection="column">
            <Flex
              mt={2}
              mb={2}
              alignItems="flex-start"
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <UndraggableImage
                src={DownloadApp}
                width={{ base: '100%', md: '48%', lg: '50%' }}
                maxWidth={{ base: 380, md: 300, lg: 350, xl: 360 }}
                position="relative"
                pt={{ base: 1, md: 0 }}
                pl={{ base: 4, md: 0 }}
                pr={{ base: 4, md: 0 }}
                pb={{ base: 8, md: 0 }}
              />
              <Box
                width={{ base: '100%', md: 0 }}
                height={{ base: 0, md: '100%' }}
                ml={{ base: 0, md: 6 }}
                mr={{ base: 0, md: 3 }}
                borderRight={{ md: '3px solid white' }}
                borderBottom={{ base: '3px solid white', md: 'none' }}
              />
              <UndraggableImage
                src={WalkIn}
                width={{ base: '100%', md: '48%', lg: '50%' }}
                maxWidth={{ base: 380, md: 300, lg: 350, xl: 360 }}
                position="relative"
                pt={{ base: 4, md: 0 }}
                ml={{ base: -5, md: 0 }}
                pl={{ base: 4, md: 0 }}
                pr={{ base: 4, md: 0 }}
                pb={{ base: 0, md: 0 }}
              />
            </Flex>
            <Text
              fontWeight="bold"
              fontSize={{ base: 13, sm: 15, md: 16, xl: 18 }}
              m={{ base: 0, sm: 4 }}
              mt={{ base: 4, sm: 4 }}
              mb={{ base: 6, sm: 4 }}
            >
              ＊須受條款及細則約束，詳情請瀏覽自家CLUB會員專區︰
              <Link
                href="https://www.hungfooktong.com/member"
                target="_blank"
                _focus={{ border: 'none' }}
              >
                www.hungfooktong.com/member
              </Link>
            </Text>
            <Flex
              ml={{ base: 0, sm: 4 }}
              mr={{ base: 0, sm: 4 }}
              mb={{ md: 0, lg: 6 }}
              alignItems="center"
            >
              <UndraggableImage
                src={SearchBar}
                maxWidth={{ base: 120, sm: 160, md: 180, lg: 190, xl: 200 }}
              />
              <Text
                ml={4}
                position="relative"
                top={{ base: '-2px', sm: '-3px', md: '-4px' }}
                fontWeight="bold"
                fontSize={{ base: 14, sm: 17, md: 'xl', lg: '2xl', xl: '3xl' }}
                color="white"
              >
                立即下載 ‧ 感受全新購物體驗
              </Text>
            </Flex>
          </Flex>
          <Flex p={2} flexDirection="column">
            <UndraggableImage
              mt={2}
              mb={4}
              src={TakeAction}
              maxWidth={{ base: 140, sm: 140, md: 140, lg: 150, xl: 160 }}
            />
            <Box
              border="solid 3px #fff"
              pt={1}
              pl={2}
              pb={3}
              pr={2}
              borderRadius={16}
              display="flex"
              flexDirection={{ sm: 'row', md: 'column' }}
              alignItems="center"
              justifyContent="center"
            >
              <Link
                href="https://apps.apple.com/hk/app/%E9%B4%BB%E7%A6%8F%E5%A0%82/id509466853"
                target="_blank"
                _focus={{ border: 'none' }}
                mr={{ base: 2, md: 0 }}
              >
                <AnimatedImage
                  mt={2}
                  src={AppStoreDownload}
                  maxWidth={{ md: 190, lg: 190, xl: 200 }}
                  width="100%"
                  maxHeight={{ base: '60px', md: '100%' }}
                  draggable="false"
                  userSelect="none"
                  whileTap={{ scale: 0.9 }}
                />
              </Link>
              <Link
                ml={{ base: 2, md: 0 }}
                href="https://play.google.com/store/apps/details?id=com.hungfooktong.hft"
                target="_blank"
                _focus={{ border: 'none' }}
              >
                <AnimatedImage
                  mt={2}
                  src={GooglePlayDownload}
                  maxWidth={{ md: 190, lg: 190, xl: 200 }}
                  maxHeight={{ base: '60px', md: '100%' }}
                  width="100%"
                  draggable="false"
                  userSelect="none"
                  whileTap={{ scale: 0.9 }}
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
});
